<template>
  <div class="mx-auto max-w-2xl py-6">
    <div class="mb-8 text-center">
      <h1 class="text-navy-800 text-2xl font-bold">Create New Order</h1>
      <p class="text-navy-500 mt-2 text-sm">
        Choose how you'd like to create this order
      </p>
    </div>

    <div class="grid gap-4" :class="agents.length > 0 ? 'sm:grid-cols-2' : ''">
      <!-- Manual Entry -->
      <button
        class="flex cursor-pointer items-start gap-4 rounded-lg border border-neutral-200 bg-white p-5 text-left shadow-sm transition-all hover:border-green-300 hover:shadow-md"
        @click="$emit('selectManual')"
      >
        <div
          class="bg-navy-100 text-navy-600 flex h-10 w-10 shrink-0 items-center justify-center rounded-full"
        >
          <i class="pi pi-pencil text-lg" />
        </div>
        <div>
          <h3 class="text-navy-800 text-sm font-semibold">Manual Entry</h3>
          <p class="text-navy-500 mt-1 text-xs">Enter order details manually</p>
        </div>
      </button>

      <!-- Agent cards -->
      <button
        v-for="agent in agents"
        :key="agent.id"
        class="flex cursor-pointer items-start gap-4 rounded-lg border border-neutral-200 bg-white p-5 text-left shadow-sm transition-all hover:border-green-300 hover:shadow-md"
        @click="$emit('selectAgent', agent)"
      >
        <div
          class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-green-100 text-green-600"
        >
          <i class="pi pi-server text-lg" />
        </div>
        <div>
          <h3 class="text-navy-800 text-sm font-semibold">
            {{ agent.name || "Unnamed Agent" }}
          </h3>
          <p class="mt-1 flex items-center gap-1.5 text-xs text-green-600">
            <span class="inline-block h-2 w-2 rounded-full bg-green-500" />
            Connected
          </p>
        </div>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ConnectedAgent } from "../../pages/Order/types"

defineProps<{
  agents: ConnectedAgent[]
}>()

defineEmits<{
  selectManual: []
  selectAgent: [agent: ConnectedAgent]
}>()
</script>
